import { Controller } from "@hotwired/stimulus";
import { filesCountChangedEventName } from '../../../../scripts/fileUpload';

export default class TouristCardController extends Controller {  
    static targets = [
        "touristCardImagesCount"
    ];

    readonly touristCardImagesCountTarget!: HTMLInputElement;

    connect() {
        this.element.addEventListener(filesCountChangedEventName, this.onTouristCardImagesCountChanged.bind(this), {});
    }

    onTouristCardImagesCountChanged(event: CustomEventInit) {
        const touristCardImagesCount = event.detail as number;
        this.touristCardImagesCountTarget.value = `${touristCardImagesCount}`;

        this.refreshFormValidation();
    }

    refreshFormValidation() {
        const form = $("form", this.element);
        if (form) form.valid();
    }
}